import Vue from 'vue';
import VueRouter from 'vue-router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import _$ from 'jquery';
import plTable, {
  PlTable, PlTableColumn, PlxTableGrid, PlxTableColumn
} from 'pl-table';

import './assets/css/common.css';
import './assets/css/index.css';
import './assets/less/common.less';
import 'df-plugins/src/log/md';
// import './assets/js/md';
import { isDesktop } from 'df-plugins/dist/desktop/win.js';
// eslint-disable-next-line import/no-unresolved
import PrintTemplate from '@/views/publicVue/printTemplate.vue';
import store from './store';
import axios from './http/index';
import Lib from './assets/js/common.js';
import router from './router';
import App from './App';

Vue.prototype.$isDesktop = function () {
  if (window.dfbridge2) {
    return true;
  }
  return isDesktop();
};

const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error);
};
Vue.use(VueRouter);
Vue.use(ElementUI);
Vue.config.productionTip = true;
window.$ = _$;
Vue.prototype.Lib = Lib;
Vue.use(plTable);
export default {
  components: {
    PlTable,
    PlTableColumn,
    PlxTableGrid,
    PlxTableColumn
  },
};

Vue.prototype.$intNum = function (value) {
  let newVal = value;
  if (!newVal && newVal != 0) {
    newVal = '';
  }
  const price = newVal.toString().replace(/[^0-9]/g, '', '');
  return price;
};

// 增加打印组件
const PrintInstance = Vue.extend(PrintTemplate);
const printComponent = new PrintInstance().$mount();
document.body.appendChild(printComponent.$el);
// methodOptions 是内容
Vue.prototype.$print = function (methodOptions) {
  printComponent.print(methodOptions);
};

// 加载全局组件
const Footer = () => import('@/views/publicVue/footer');
const Details = () => import('@/views/publicVue/details');
const BillRecord = () => import('@/views/publicVue/billRecord');
const Repayment = () => import('@/views/publicVue/repayment');
const RepayRecord = () => import('@/views/publicVue/repayRecord');
const NoneData = () => import('@/views/publicVue/noneData');
const DelDig = () => import('@/views/publicVue/delDig');
const MemberDig = () => import('@/views/publicVue/memberDig');
const Theme = () => import('@/views/publicVue/theme');
const DateRange = () => import('@/views/publicVue/template/picker/daterange');
const DeadlineDig = () => import('@/views/publicVue/deadlineDig');
const YzBtn = () => import('@/views/publicVue/template/button/index');
const DefaultImg = () => import('@/views/publicVue/defaultImg');
const PonsumptionCode = () => import('@/views/publicVue/consumptionCode');
const CoverImg = () => import('@/views/publicVue/coverImg');
const DatePicker = () => import('@/views/publicVue/template/datePicker/datePicker');
const Activity = () => import('@/views/publicVue/template/activity/tagOne');
const ActivityTwo = () => import('@/views/publicVue/template/activity/tagTwo');
const UploadPictures = () => import('@/views/publicVue/template/upload/pictures');
const UploadAttachment = () => import('@/views/publicVue/template/upload/attachment');
const Autograph = () => import('@/views/publicVue/template/autograph/index');
const CustomerInfo = () => import('@/views/publicVue/template/customer/details');
// 注册全局组件
Vue.component('GtFooter', Footer); // 公共底部样式
Vue.component('GtDetails', Details); // 查看详情弹出窗口
Vue.component('GtBillRecord', BillRecord); // 赊账记录
Vue.component('GtRepayment', Repayment); // 还款操作
Vue.component('GtRepayRecord', RepayRecord); // 还款记录
Vue.component('GtNoneData', NoneData); // 没有数据
Vue.component('GtDelDig', DelDig); // 删除数据弹出窗口
Vue.component('GtMemberDig', MemberDig); // 新增会员弹出窗口
Vue.component('GtTheme', Theme); // 换肤
Vue.component('YzDaterange', DateRange); // 时间段
Vue.component('YzBtn', YzBtn); // 按钮
Vue.component('GtDeadlineDig', DeadlineDig); // 过期提示弹出窗口
Vue.component('GtDefaultImg', DefaultImg); // 默认图片
Vue.component('GtConsumptionCode', PonsumptionCode);
Vue.component('GtCoverImg', CoverImg); // 自适应图片
Vue.component('DatePicker', DatePicker); // 日期组件
Vue.component('Activity', Activity); // 活动按钮组件
Vue.component('ActivityTwo', ActivityTwo); // 活动按钮组件二
Vue.component('UploadPictures', UploadPictures); // 上传图片组件
Vue.component('UploadAttachment', UploadAttachment); // 上传附件组件
Vue.component('Autograph', Autograph); // 上传附件组件
Vue.component('GtCustomerInfo', CustomerInfo); // 公共底部样式

// import VConsole from 'vconsole/dist/vconsole.min.js'
// let vConsole = new VConsole()
const tokenOfUrl = Lib.getUrlKey('loginToken');
const isHD = Lib.getUrlKey('isHD');

Vue.directive('focus', {
  inserted: (el) => {
    el.querySelector('input').focus();
  },
  componentUpdated: (el) => {
    el.querySelector('input').focus();
  }
});

// let timeStr;

// const rewriteHis = function (type) {
//   const origin = window.history[type];
//   return function () {
//     const rs = origin.apply(this);
//     const e = new Event(type.toLocaleLowerCase());
//     window.dispatchEvent(e);
//     return rs;
//   };
// };
// window.history.pushState = rewriteHis('pushState');

// window.history.replaceState = rewriteHis('replaceState');

// window.addEventListener('onload', () => {
//   timeStr = new Date().getTime();
// });

// window.addEventListener('popstate', () => {
//   const t = new Date().getTime() - timeStr;
//   timeStr = new Date().getTime();
//   console.log(`待了时长popstate：${t}`);
// });

// window.addEventListener('pushstate', () => {
//   const t = new Date().getTime() - timeStr;
//   timeStr = new Date().getTime();
//   console.log(`待了时长pushstate：${t}`);
// });

// window.addEventListener('replacestate', () => {
//   const t = new Date().getTime() - timeStr;
//   timeStr = new Date().getTime();
//   console.log(`待了时长replacestate：${t}`);
// });
if (tokenOfUrl && tokenOfUrl !== 'undefined') {
  window.sessionStorage.token = tokenOfUrl;
}
if (window.dfbridge2) {
  init();
} else if (isDesktop() === true) {
  init();
} else if (isHD == 1) {
  window.sessionStorage.ishd = isHD;
  init();
} else {
  const { token } = window.sessionStorage;
  const code = Lib.getUrlKey('code');
  if ((!token && code) || (token === 'undefined' && code)) {
    axios.get('/erp/login/verify4Pc', {
      code
    }).then((res) => {
      if (res.data.code == 0) {
        res.data.data.loginToken && (window.sessionStorage.token = res.data.data.loginToken);
        init();
      } else {
        init();
      }
    });
  } else {
    init();
  }
}

function init() {
  /* eslint-disable no-new */
  new Vue({
    router,
    store,
    axios,
    created() {
      // 初始化后加载依赖包
      require('gt-maidian');
    },
    render: (h) => h(App)
  }).$mount('#app');

  // document.onkeydown = function () {
  //     if (window.event.keyCode == 27) {
  //         window.event.keyCode = 0;
  //         window.event.returnValue = false;
  //     }
  // }
}
